const DOC_TYPE_RE =
  /\b(application|plaint|petition|written statement|written reply|reply|replication|rejoinder|affidavit|appeal|memo|memorandum|suit|complaint|notice|demand|bail|vakalatnama|caveat|objection|counter|synopsis|challan|interim application|stay|injunction|revision|review|reference|execution|vakalat|power of attorney|legal notice)\b/i;

/** Suggest a tab title from the lawyer's drafting prompt. */
export function resolveCounselTabTitle(prompt: string): string {
  const trimmed = prompt.trim();
  const match = trimmed.match(DOC_TYPE_RE);
  if (match?.[1]) {
    return match[1]
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
  if (/\bdraft\b/i.test(trimmed)) return 'Draft';
  if (/\bwrite\b/i.test(trimmed)) return 'Draft';
  return 'New document';
}

export function createCounselDraftTab(title: string): Promise<{ tabId: string; title: string }> {
  return new Promise((resolve, reject) => {
    const timeout = window.setTimeout(() => {
      window.removeEventListener('lexcounsel-draft-tab-ready', onReady);
      reject(new Error('Timed out while opening a new document tab.'));
    }, 10_000);

    const onReady = (event: Event) => {
      window.clearTimeout(timeout);
      window.removeEventListener('lexcounsel-draft-tab-ready', onReady);
      const detail = (event as CustomEvent<{ tabId?: string; title?: string }>).detail;
      if (!detail?.tabId) {
        reject(new Error('Could not open a new document tab.'));
        return;
      }
      resolve({ tabId: detail.tabId, title: detail.title?.trim() || title });
    };

    window.addEventListener('lexcounsel-draft-tab-ready', onReady);
    window.dispatchEvent(
      new CustomEvent('lexcounsel-create-draft-tab', { detail: { title } }),
    );
  });
}
